import type { IconSvgObject } from './types';

const ChartEvaluationIcon: IconSvgObject = [
  ["path", { d: "M21 21H3V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 21L7 16M21 4L19 7M8.44444 14L10 12L14 15L17.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartEvaluationIcon;
